import { add, importAndReset, load, remove, update } from 'sdk/payerType';
import { ADD, LOAD, REMOVE, UPDATE, IMPORT } from 'model/payerType';
import { callAction, ORM } from 'util/index';
import { takeEvery } from 'redux-saga/effects';
import { loadFSPProfileAction } from './export';

function* addAndPopulateExport(action) {
  const addAction = callAction({
    api: add,
    dataName: ORM,
    formatSuccessMessage: () => 'Payer Types were successfully added',
    type: ADD,
  });

  if (yield addAction(action)) {
    yield loadFSPProfileAction(action);
  }
}

export const importPayerTypes = () =>
  callAction({
    api: importAndReset,
    dataName: ORM,
    formatSuccessMessage: () => 'Payer Types were successfully imported',
    type: IMPORT,
  });

function* importAndPopulateExport(action) {
  const importAndResetAction = importPayerTypes();

  if (yield importAndResetAction(action)) {
    yield loadFSPProfileAction(action);
  }
}
function* removeAndPopulateExport(action) {
  const removeAction = callAction({
    api: remove,
    dataName: ORM,
    formatSuccessMessage: () => 'Payer Type was successfully removed',
    type: REMOVE,
  });

  if (yield removeAction(action)) {
    yield loadFSPProfileAction(action);
  }
}
function* updateAndPopulateExport(action) {
  const updateAction = callAction({
    api: update,
    dataName: ORM,
    formatSuccessMessage: () => 'Payer Type was successfully updated',
    type: UPDATE,
  });

  if (yield updateAction(action)) {
    yield loadFSPProfileAction(action);
  }
}

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );

  yield takeEvery(ADD.ACTION, addAndPopulateExport);

  yield takeEvery(IMPORT.ACTION, importAndPopulateExport);

  yield takeEvery(REMOVE.ACTION, removeAndPopulateExport);

  yield takeEvery(UPDATE.ACTION, updateAndPopulateExport);
}
